module.exports = __webpack_public_path__ + "img/checkmark-checked.f27cef42.svg";